export default "__VITE_ASSET__eUgq4lxD__"